import React, { CSSProperties, FC } from 'react'

interface Props {
  children: React.ReactElement | React.ReactElement[]
  color?: string
  style?: CSSProperties
}

const LoadingSquare: FC<Props> = (props) => {
  const {
    children,
    color,
    style,
  } = props

  return (
    <div style={style}>
      <div className="self-building-square-spinner">
        <div className="square" />
        <div className="square" />
        <div className="square" />
        <div className="square clear" />
        <div className="square" />
        <div className="square" />
        <div className="square clear" />
        <div className="square" />
        <div className="square" />
      </div>
      <div
        style={{
          textAlign: "center",
          color: color,
        }}
      >
        {children}
      </div>
    </div>
  )
}

LoadingSquare.defaultProps = {
  color: "#999999",
}

export default LoadingSquare
